export const ERRORLIST = "ErrorList";
export const BOUNDARYNODEEERROR = "BoundaryNodeError";
export interface IDataErrorList {
  ErrorType: string;
  Errors: Array<IExtractionError | IBoundaryNodeError | any>;
}

export interface IBoundaryNodeError {
  ErrorType: string;
  Id: string;
  X: number;
  Y: number;
  Code: string;
  ErrorMessage: string;
  ChildErrors: IDataErrorList;
}
  
export interface IExtractionError {
  ErrorType: string;
  ProviderName: string;
  ItemName: string;
  ExtractionType: string;
  ErrorMessage: string;
  ChildErrors: IDataErrorList;
}
